import { ArrowDownRight } from "lucide-react";

const HERO_BG =
  "https://customer-assets.emergentagent.com/job_aerial-photo-book/artifacts/w82f8sf7_IMG_3357.jpeg";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      {/* BG */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Sunset clouds over Lake Anna, Virginia"
          className="w-full h-full object-cover object-center scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#05080F]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(229,169,59,0.18),_transparent_55%)]" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 flex flex-col">
        <div className="flex-1 flex items-end pb-24 md:pb-32">
          <div className="max-w-5xl fade-up">
            <div className="mb-6 md:mb-8">
              <span className="overline text-[#E5A93B]">
                Lake Anna, VA · est. 2026
              </span>
            </div>
            <h1
              data-testid="hero-headline"
              className="font-black tracking-[-0.03em] text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] leading-[0.9] text-white"
            >
              The lake,
              <br />
              from a <em className="not-italic text-[#E5A93B]">new altitude.</em>
            </h1>
            <p className="mt-8 md:mt-10 text-base md:text-lg text-white/70 max-w-xl leading-relaxed font-light">
              Aqua Aerials LKA is a small drone studio crafting cinematic aerial
              photography &amp; video for Lake Anna&apos;s lakefront homes, boats,
              and waterborne moments.
            </p>

            <div className="mt-10 md:mt-12 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                data-testid="hero-book-cta"
                className="group inline-flex items-center gap-3 bg-[#E5A93B] hover:bg-[#FACC15] text-black px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-colors"
              >
                Book a Shoot
                <ArrowDownRight
                  size={16}
                  className="transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5"
                />
              </a>
              <a
                href="#gallery"
                data-testid="hero-work-cta"
                className="inline-flex items-center gap-3 border border-white/20 text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white/5 transition-colors"
              >
                See the Work
              </a>
            </div>
          </div>
        </div>

        {/* Right meta badge */}
        <div className="hidden lg:flex absolute right-16 top-32 flex-col items-end gap-1">
          <span className="overline text-white/40">N 38.0° W 77.7°</span>
          <span className="overline text-white/40">FAA Part 107</span>
        </div>
      </div>

      {/* Editorial ribbon */}
      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-white/10 bg-black/30 backdrop-blur-sm">
        <div className="overflow-hidden">
          <div className="flex gap-16 py-5 whitespace-nowrap animate-marquee">
            {[
              "Real Estate Aerials",
              "Boat & Watersports Filming",
              "Cinematic Lake Videos",
              "4K · 60fps",
              "Lake Anna",
              "Real Estate Aerials",
              "Boat & Watersports Filming",
              "Cinematic Lake Videos",
              "4K · 60fps",
              "Lake Anna",
            ].map((t, i) => (
              <span
                key={i}
                className="font-mono text-xs tracking-[0.3em] uppercase text-white/50 flex items-center gap-16"
              >
                {t}
                <span className="h-1 w-1 bg-[#E5A93B] rounded-full" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
